module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_palm-666804e2a076bb5dec8b52dce80a3398.svg";